import { Col, Collapse, Row } from "antd";
import { VFC } from "react";
import { MemberPanel } from "./MemberCard/MemberPanel";
import { useSelector } from "../../../../redux/store";
import { GameStatusSection } from "./GameStatusSection/GameStatusSection";
import { DocumentReference } from "firebase/firestore";
import { WikipedaPanel } from "./WikipedaPanel";
import { membersSelector } from "../../../../redux/selectors/membersSelector";

export const ComponentsCollapse: VFC<{
  className?: string;
  gameRef: DocumentReference;
}> = ({ className, gameRef }) => {
  const game = useSelector((state) => state.game.game);
  const currentUser = useSelector((state) => state.auth.user);

  const isGameMaster = game?.masterUserId === currentUser?.uid;
  const members = useSelector(membersSelector);
  return (
    <Row gutter={[16, 16]} style={{ padding: 16 }}>
      <Col span={24}>
        <GameStatusSection
          game={game}
          gameRef={gameRef}
          isGameMaster={isGameMaster}
        />
      </Col>
      <Col span={24}>
        <Collapse>
          <WikipedaPanel key={"wiki"} header={"Begriffserklärung"} />
          <MemberPanel
            key={"members"}
            header={"Mitspieler"}
            isCurrentUserGameMaster={isGameMaster}
            members={members}
          />
        </Collapse>
      </Col>
      <Col span={24}></Col>
    </Row>
  );
};
